export default __webpack_public_path__ + "static/media/car4.b049f9e6.png";